<template>
  <div class="roadblock">
    <div class="roadblock-content">
      <div class="cta">
        <h5>
          <span>Discover, buy, &amp; sell</span> the products you need to grow your business
        </h5>
        <p>
          The right tool can put time back on your calendar—and money back in your pocket.
          Find your new favorite thing today.
        </p>
      </div>
      <div class="image">
        <img
          src="~/static/explore-roadblock.svg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    utmSource() {
      return this.$route.query.utm_source;
    },
    utmCampaign() {
      return this.$route.query.utm_campaign;
    },
    utmMedium() {
      return this.$route.query.utm_medium;
    },
    url() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = [];
      Object.keys(utm).forEach((key) => {
        const val = utm[key];

        if (val) {
          params.push(`${key}=${val}`);
        }
      });

      if (params.length) {
        return `/plus?${params.join('&')}`;
      }

      return '/plus/';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.roadblock {
  background: #f5f5f9;
  margin-bottom: 60px;
  margin-left: -30px;
  margin-right: -30px;
  padding: 32px 64px;
}

.roadblock-content {
  display: flex;
  flex-direction: column;
}

.image {
  flex: 1 0 0;
  padding-left: 16px;
}

.image img {
  max-height: 320px;
  width: 100%;
}

.success {
  background: #0a840a;
  padding: 16px 20px;
  color: #fff;
  display: inline-flex;
  align-items: center;
}

.success img {
  margin-right: 16px;
}

.cta {
  flex: 1 0 0;
}

.cta img {
  height: 16px;
  margin-bottom: 16px;
}

.cta h5 {
  font-family: Barlow, sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
}

.cta h5 span {
  color: #07c93b;
}

.cta p {
  font-size: 16px;
  line-height: 24px;
}

.cta input {
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #000;
  font-size: 16px;
  padding: 6px 12px;
  width: 285px;
}

.cta .button {
  background: #ffbc00;
  border-radius: 40px;
  color: #1b1b1b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 24px;
  text-decoration: none;
  border: 0;
  margin-left: 8px;
  display: inline-block;
  text-align: center;
}

.cta .button:focus {
  border: 0;
  outline: none;
}

@include media-breakpoint-up(sm) {
  .roadblock-content {
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
    max-width: 1140px;
  }
}

@include media-breakpoint-down(xs) {
  .roadblock {
    flex-direction: column;
  }

  .cta {
    order: 2;
  }

  .image {
    order: 1;
    margin-bottom: 16px;
  }

  .image img {
    margin: 0 auto;
    display: block;
    width: 80%;
  }
}

@include media-breakpoint-down(md) {
  .roadblock {
    margin-left: -20px;
    margin-right: -20px;
    padding: 32px;
  }

  .cta h5 {
    font-size: 28px;
    line-height: 32px;
  }
}

@include media-breakpoint-down(lg) {
  .cta input {
    width: 100%;
  }

  .cta button {
    margin: 16px 0 0;
    width: 100%;
  }
}
</style>
